<template>
  <div class="app-wrapper">
    <layout-navbar></layout-navbar>
    <div class="main-container">
      <!--<div class="titleInfo">项目库>全部</div>-->
      <div class="main">
        <!-- 左侧导航 -->
        <ul class="nav" :class="[isSelected]">
          <template v-for="(item, index) in menuData" style="width: 100%">
            <li
              :class="{ active: currentIndex === index }"
              :key="index"
              v-if="
                item.id === '0' ||
                  (projectSummaryUrl !== null && item.id === '1') ||
                  (videoLogoImageUrl !== null && item.id === '13') ||
                  (demoLink.length > 0 && item.id === '2') ||
                  (baseInfo.length > 0 && item.id === '3') ||
                  (highlightsData.length > 0 && item.id === '4') ||
                  (testImage !== null && item.id === '5') ||
                  (solutionData.length > 0 && item.id === '6') ||
                  (functionaUrl !== null && item.id === '7') ||
                  (technicalUrl !== null && item.id === '8') ||
                  (productArchitectureUrl !== null && item.id === '9') ||
                  (productStructureUrl !== null && item.id === '10') ||
                  (courseOutData.length > 0 && item.id === '11') ||
                  (projectToolsl.length > 0 && item.id === '12')
              "
            >
              <a
                href="javascript:;"
                @click="selectMenu(index, $event)"
                :class="item.icon"
              >
                <em></em>
                {{ item.name }}
              </a>
            </li>
          </template>
        </ul>
        <!-- 左侧导航 end -->

        <div
          class="container productSec"
          ref="rightContent"
          @mousewheel="scrool"
        >
          <div class="food-list-hook">
            <h2 class="titInfo">
              {{ modelData.name }}
              <span
                v-if="modelData.version !== null && modelData.version !== ''"
                >{{ modelData.version }}</span
              >
              <a
                @click.prevent="goBack"
                class="rightMenu goback"
                v-track="['返回', '文字点击']"
                >返回</a
              >
              <!-- <router-link
                :to="{
                  path: '/',
                  query: {
                    subjectID: this.$route.query.subjectID,
                  },
                }"
                class="rightMenu goback"
                >返回</router-link
              > -->
            </h2>
            <div class="surveyBox">
              <div class="leftInfo"></div>
              <div class="rightInfo"></div>
              <div class="surverInfo">
                <div class="infoPosition">
                  <p class="infoTip">
                    <!--<img v-lazy="modelData.logoImage" v-if="modelData.logoImage !== null"/>-->
                    <img
                      v-lazy="{
                        src: modelData.logoImage,
                        loading: require('./../../../assets/logoImage.jpg'),
                      }"
                      v-if="modelData.logoImage !== null"
                    />

                    <em
                      class="fontSize18"
                      v-if="modelData.tradename !== null"
                      >{{ modelData.tradename }}</em
                    >
                    <span v-for="val in modelData.platforms" :key="val.id">
                      {{ val.name }}
                    </span>
                    <!--<em class="rightMenu"><i class="el-icon-warning"></i>更新日志</em>-->
                  </p>
                  <p v-if="modelData.lastUpdate !== null">
                    更新时间：{{ modelData.lastUpdate }}
                  </p>
                </div>
              </div>
              <div class="description">{{ modelData.description }}</div>
            </div>

            <!-- 滚动图 -->
            <viewer
              :images="modelData.pAdImages"
              class="imgVideo"
              v-if="
                this.pVideoUrlData.length !== 0 ||
                  modelData.pAdImages.length !== 0
              "
            >
              <swiper :options="swiperOption">
                <template v-if="this.pVideoUrlData.length !== 0">
                  <swiper-slide
                    class="videoP"
                    v-for="item in pVideoUrlData"
                    :key="item.videoLogoImage"
                    style="width: 300px !important"
                  >
                    <span
                      class="videoMain"
                      @click="handleVideo(modelData, $event)"
                      v-track="['项目介绍', '点击播放']"
                    >
                      <span
                        :style="{
                          backgroundImage: 'url(' + item.videoLogoImage + ')',
                        }"
                        v-if="item.videoLogoImage !== null"
                      ></span>
                      <span class="videoBg" v-else></span>
                    </span>
                  </swiper-slide>
                </template>
                <template v-if="modelData.pAdImages.length !== 0">
                  <swiper-slide
                    class="1"
                    id="index"
                    v-for="(item, index) in modelData.pAdImages"
                    :key="index"
                    style="width: 300px !important"
                  >
                    <img
                      v-lazy="{
                        src: item.url,
                        loading: require('./../../../assets/wheelplanting.jpg'),
                      }"
                      class="imgPosition"
                    />
                  </swiper-slide>
                </template>
                <template
                  v-if="
                    this.pVideoUrlData.length !== 0 ||
                      modelData.pAdImages.length !== 0
                  "
                >
                  <div class="swiper-pagination" slot="pagination"></div>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </template>
              </swiper>
            </viewer>
            <!-- 滚动图 end -->
          </div>
          <!-- 成果展示 -->
          <div class="food-list-hook" ref="div0">
            <p class="imgBox imgPad0" style="text-align: center">
              <img
                v-lazy="{
                  src: projectSummaryUrl,
                  loading: require('./../../../assets/drawing.jpg'),
                }"
              />
            </p>
          </div>
          <!-- end -->
          <!-- 学员作品 -->
          <div class="food-list-hook" ref="div02">
            <p class="imgBox imgPad0" style="text-align: center">
              <img
                v-lazy="{
                  src: videoLogoImageUrl,
                  loading: require('./../../../assets/drawing.jpg'),
                }"
              />
            </p>
          </div>
          <!-- end -->
          <div class="conBox food-list-hook" ref="div01">
            <h3>所用软件</h3>
            <div class="allTools">
              <ul>
                <li v-for="(item, index) in projectToolsl" :key="index">
                  <img :src="item.logoImage.url" :title="item.name" />
                </li>
              </ul>
            </div>
          </div>
          <div class="conBox food-list-hook" ref="div1">
            <h3>演示地址</h3>
            <ul class="adressList">
              <li v-for="(item, index) in demoLink" :key="item.url">
                <span @mouseenter="enter(index)" @mouseleave="leave()">
                  <em v-if="item.twoUrl !== ''" class="current el-icon-two">
                    <em>{{ item.name }}</em>
                  </em>
                  <em v-else>
                    <a
                      :href="'http://' + item.url"
                      target="_blank"
                      class="el-icon-warn"
                      v-if="item.conten.length > 0"
                      v-track="[item.name, '文字点击']"
                      >{{ item.name }}</a
                    >
                    <a
                      :href="'http://' + item.url"
                      target="_blank"
                      v-else
                      v-track="[item.name, '文字点击']"
                    >
                      {{ item.name }}
                    </a>
                  </em>
                </span>

                <div
                  v-show="seen && index == current"
                  class="index-show"
                  v-if="item.conten.length > 0 || item.twoUrl !== ''"
                >
                  <div class="star"></div>
                  <div v-if="item.conten.length > 0">
                    <p v-for="(val, i) in item.conten" :key="i">{{ val }}</p>
                  </div>
                  <div v-else>
                    <img :src="'https://' + item.twoUrl" />
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="conBox food-list-hook" ref="div2">
            <h3>基本信息</h3>
            <div class="collapseList">
              <div v-for="(item, index) in baseInfo" :key="index">
                <div
                  class="baseTitle pos"
                  v-if="item.desc !== null && item.desc !== ''"
                  @click="setIndex(index)"
                >
                  <i
                    class="el-icon-caret-right"
                    :class="{ activeClass: index == currents }"
                  ></i>
                  {{ item.title }}
                </div>
                <div class="baseTitle" v-else>{{ item.title }}</div>
                <div
                  class="baseInfolist baseShadow"
                  v-if="item.desc !== null && item.desc !== ''"
                  v-show="activeIndex === index"
                >
                  <span v-for="(val, i) in item.desc" :key="i">{{ val }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="conBox food-list-hook" ref="div3">
            <h3>技术亮点</h3>
            <ul class="itemList">
              <li v-for="(item, index) in highlightsData" :key="index">
                <span v-if="item !== ''">
                  <em></em>
                  {{ item }}
                </span>
              </li>
            </ul>
          </div>

          <div class="conBox food-list-hook" ref="div4">
            <h3>测试框架图</h3>
            <p class="imgBox">
              <img
                v-lazy="{
                  src: testImage,
                  loading: require('./../../../assets/drawing.jpg'),
                }"
              />
            </p>
          </div>

          <div class="conBox food-list-hook" ref="div5">
            <h3>技术解决方案</h3>
            <ul class="itemList soluList">
              <li v-for="(item, index) in solutionData" :key="index">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item"
                  placement="bottom-start"
                >
                  <el-button class="el-button--medium">
                    <em></em>
                    {{ item }}
                  </el-button>
                </el-tooltip>
              </li>
            </ul>
          </div>

          <div class="conBox food-list-hook" ref="div6">
            <h3>功能架构图</h3>
            <p class="imgBox">
              <img
                v-lazy="{
                  src: functionaUrl,
                  loading: require('./../../../assets/drawing.jpg'),
                }"
              />
            </p>
          </div>

          <div class="conBox food-list-hook" ref="div7">
            <h3>技术架构图</h3>
            <p class="imgBox">
              <img
                v-lazy="{
                  src: technicalUrl,
                  loading: require('./../../../assets/drawing.jpg'),
                }"
              />
            </p>
          </div>

          <div class="conBox food-list-hook" ref="div8">
            <h3>产品架构图</h3>
            <p class="imgBox">
              <img
                v-lazy="{
                  src: productArchitectureUrl,
                  loading: require('./../../../assets/drawing.jpg'),
                }"
              />
            </p>
          </div>

          <div class="conBox food-list-hook" ref="div9">
            <h3>产品结构图</h3>
            <p class="imgBox">
              <img
                v-lazy="{
                  src: productStructureUrl,
                  loading: require('./../../../assets/drawing.jpg'),
                }"
              />
            </p>
          </div>

          <div class="conBox food-list-hook" ref="div10">
            <h3>
              课程大纲
              <a
                class="rightMenu seeLink"
                v-if="courseTrialLink !== null"
                style="margin-top: -8px"
                :href="courseTrialLink"
                target="_blank"
                >课程学习</a
              >
            </h3>
            <div>
              <el-collapse v-model="active" accordion>
                <el-collapse-item
                  title
                  :name="index + 1"
                  v-for="(item, index) in courseOutData"
                  :key="index"
                  v-track="[item.name, '文字点击']"
                >
                  <span slot="title" class="baseTitle">
                    {{ item.titles }}
                    <!--<em class='el-icon-video-camera-solid' v-if='item.video.name!==""&&item.video.name==="视频"' @click="handleVideo(item.video,$event)"></em>-->
                    <!--<em class='el-icon-link' v-else-if='item.video.url!==""||item.video.url==="链接"' @click="handleLink(item,$event)"></em>-->
                  </span>
                  <div
                    class="baseInfolist courseInfo"
                    v-for="(val, num) in item.desc"
                    :key="num"
                  >
                    <em class="courseOutTitle">{{ val.title }}</em>
                    <ul class="courseOutList">
                      <li
                        v-for="(v, n) in val.conten.split(/↵|\r|\n|\r\n/)"
                        :key="n"
                      >
                        {{ v }}
                      </li>
                    </ul>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
    <!-- <span class="topClass" @click="goTop"></span> -->
  </div>
</template>

<script>
import layoutNavbar from "./../../components/layoutNavbar";
import baseApi from "@/base/baseApi";
import MenuAdd from "./../../components/video";
import { Content } from "../../../gqlapi/ContentDetail.js";
export default {
  name: "layout",
  components: {
    layoutNavbar,
    MenuAdd,
  },
  data() {
    return {
      currents: -1,
      activeIndex: -1,
      isSelected: "navon0-selected",
      active: "1",
      detailId: "",
      menuData: [],
      baseData: {},
      demoLink: [],
      baseInfo: [],
      courseOutData: [],
      highlightsData: [],
      solutionData: [],
      currentOffset: 0,
      windowSize: 0,
      paginationFactor: 235,
      functionaUrl: "",
      technicalUrl: "",
      testImage: "",
      productArchitectureUrl: "",
      productStructureUrl: "",
      projectSummaryUrl: "",
      videoLogoImageUrl: "",
      courseTrialLink: "",
      modelData: {
        name: "",
        tradename: "",
        platforms: "",
        lastUpdate: "",
        description: "",
        pVideoUrl: "",
        videologoImage: "",
        pAdImages: "",
        logoImage: "",
        version: "",
      },
      pVideoUrlData: [],
      listHeight: [],
      currentIndex: 0,
      distance: 0,
      total: 0,
      step: 0,
      seen: false,
      current: 0,
      swiperOption: {
        slidesPerView: "auto",

        spaceBetween: 20,
        slidesPerGroup: 3,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      projectToolsl: [],
    };
  },
  created() {
    this.menuData = baseApi.menuList;
    this.detailId = sessionStorage.getItem("detailsId");
    this.getData(this.detailId);
    this.$nextTick(() => {
      setTimeout(() => {
        this._calculateHeight();
        //document.body.scrollTop = 0;
        //document.documentElement.scrollTop = 0;
      }, 3000);
    });
  },
  computed: {
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor *
          -1 *
          (this.modelData.pAdImages.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    goBack() {
      let path = "/testHome";
      let subjectID = sessionStorage.getItem("subjectID");
      if (subjectID === "5") {
        path = "/pm";
      } else if (subjectID === "6") {
        path = "/ui";
      }
      this.$router.push({
        path: path,
      });
    },
    handleVideo(url, e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(url);
    },
    // 获取详情
    getData(detailId) {
      this.$axios
        .post("/api", {
          operationName: "Content",
          variables: {
            id: detailId,
          },
          query: Content,
        })
        .then((res) => {
          this.baseData = res.data.data;

          //项目情况
          this.modelData.name = this.baseData.pContent.name;
          this.modelData.version = this.baseData.pContent.version;
          if (this.baseData.pContent.trade !== null) {
            this.modelData.tradename = this.baseData.pContent.trade.name;
          } else {
            this.modelData.tradename = null;
          }

          this.modelData.platforms = this.baseData.pContent.platforms;
          this.modelData.lastUpdate = this.baseData.pContent.lastUpdate;
          this.modelData.description = this.baseData.pContent.description;
          this.modelData.pVideoUrl = this.baseData.pContent.pVideoUrl;

          this.modelData.pAdImages = this.baseData.pContent.pAdImages;

          this.modelData.testImage = this.baseData.pContent.testArchitectureImage;

          if (this.baseData.pContent.videoLogoImage === null) {
            this.modelData.videologoImage = this.baseData.pContent.videoLogoImage;
          } else {
            this.modelData.videologoImage = this.baseData.pContent.videoLogoImage.url;
          }
          var pvideoData = [];
          if (
            this.modelData.pVideoUrl !== null &&
            this.modelData.pVideoUrl !== ""
          ) {
            var pvideo = {
              videoUrl: this.modelData.pVideoUrl,
              videoLogoImage: this.modelData.videologoImage,
            };
            pvideoData.push(pvideo);
            this.pVideoUrlData = pvideoData;
          } else {
            this.pVideoUrlData.length = 0;
          }
          //项目logo
          if (this.baseData.pContent.detailLogoImage === null) {
            debugger;
            this.modelData.logoImage = this.baseData.pContent.detailLogoImage;
          } else {
            this.modelData.logoImage = this.baseData.pContent.detailLogoImage.url;
          }
          //测试框架图
          if (this.baseData.pContent.testArchitectureImage === null) {
            this.testImage = this.baseData.pContent.testArchitectureImage;
          } else {
            this.testImage = this.baseData.pContent.testArchitectureImage.url;
          }
          //功能架构图
          if (this.baseData.pContent.functionalArchitectureDiagram === null) {
            this.functionaUrl = this.baseData.pContent.functionalArchitectureDiagram;
          } else {
            this.functionaUrl = this.baseData.pContent.functionalArchitectureDiagram.url;
          }
          //技术架构图
          if (this.baseData.pContent.technicalArchitectureDiagram === null) {
            this.technicalUrl = this.baseData.pContent.technicalArchitectureDiagram;
          } else {
            this.technicalUrl = this.baseData.pContent.technicalArchitectureDiagram.url;
          }

          //产品架构图
          if (this.baseData.pContent.productArchitectureDiagramImage === null) {
            this.productArchitectureUrl = this.baseData.pContent.productArchitectureDiagramImage;
          } else {
            this.productArchitectureUrl = this.baseData.pContent.productArchitectureDiagramImage.url;
          }

          //产品结构图
          if (this.baseData.pContent.productStructureImage === null) {
            this.productStructureUrl = this.baseData.pContent.productStructureImage;
          } else {
            this.productStructureUrl = this.baseData.pContent.productStructureImage.url;
          }

          //项目总结
          if (this.baseData.pContent.projectSummaryImage === null) {
            this.projectSummaryUrl = this.baseData.pContent.projectSummaryImage;
          } else {
            this.projectSummaryUrl = this.baseData.pContent.projectSummaryImage.url;
          }

          //学员作品
          if (this.baseData.pContent.videoLogoImage === null) {
            this.videoLogoImageUrl = this.baseData.pContent.videoLogoImage;
          } else {
            this.videoLogoImageUrl = this.baseData.pContent.videoLogoImage.url;
          }

          if (
            this.baseData.pContent.courseTrial === null ||
            this.baseData.pContent.courseTrial === ""
          ) {
            this.courseTrialLink = null;
          } else {
            this.courseTrialLink = this.baseData.pContent.courseTrial;
          }
          //所有软件
          if (this.baseData.pContent.tools.length > 0) {
            this.projectToolsl = this.baseData.pContent.tools;
            // console.log(this.projectToolsl);
          }

          //演示地址
          var dataLink = [
            this.baseData.pContent.demoLink1,
            this.baseData.pContent.demoLink2,
            this.baseData.pContent.demoLink3,
            this.baseData.pContent.demoLink4,
            this.baseData.pContent.demoLink5,
            this.baseData.pContent.demoLink6,
          ];
          var data = [];

          for (var i = 0; i < dataLink.length; i++) {
            if (dataLink[i] !== "标题|链接|说明" && dataLink[i] !== "") {
              data = dataLink[i].split("|");
              this.demoLink.push(data);
            }
          }
          var userObj = {};
          var userData = [];
          for (var n = 0; n < this.demoLink.length; n++) {
            var twoUrl = "";
            var imgReg = ["jpg", "png", "gif"];
            var index = this.demoLink[n][1].lastIndexOf(".");
            var ext = this.demoLink[n][1].substr(index + 1);
            for (var t = 0; t < imgReg.length; t++) {
              if (ext.replace(/\s+/g, "") === imgReg[t]) {
                twoUrl = this.demoLink[n][1];
              }
            }

            if (this.demoLink[n][2] !== undefined) {
              this.demoLink[n][2] = this.demoLink[n][2].split(" ");
              userObj = {
                name: this.demoLink[n][0],
                url: this.demoLink[n][1],
                twoUrl: "",
                conten: this.demoLink[n][2],
              };
            } else {
              userObj = {
                name: this.demoLink[n][0],
                url: this.demoLink[n][1],
                twoUrl: twoUrl,
                conten: [],
              };
            }

            userData.push(userObj);
          }
          this.demoLink = userData;
          //基本信息
          var baseInfoTitle = [
            this.baseData.pContent.baseInfoTitle1,
            this.baseData.pContent.baseInfoTitle2,
            this.baseData.pContent.baseInfoTitle3,
            this.baseData.pContent.baseInfoTitle4,
            this.baseData.pContent.baseInfoTitle5,
            this.baseData.pContent.baseInfoTitle6,
            this.baseData.pContent.baseInfoTitle7,
            this.baseData.pContent.baseInfoTitle8,
          ];
          var baseInfoDesc = [
            this.baseData.pContent.baseInfoDesc1,
            this.baseData.pContent.baseInfoDesc2,
            this.baseData.pContent.baseInfoDesc3,
            this.baseData.pContent.baseInfoDesc4,
            this.baseData.pContent.baseInfoDesc5,
            this.baseData.pContent.baseInfoDesc6,
            this.baseData.pContent.baseInfoDesc7,
            this.baseData.pContent.baseInfoDesc8,
          ];
          this.infoData(baseInfoTitle, baseInfoDesc, this.baseInfo, "base");
          //技术亮点
          var highlightsData;
          if (this.baseData.pContent.technicalHighlights !== null) {
            highlightsData = this.baseData.pContent.technicalHighlights.split(
              /↵|\n/
            );
            this.forData(highlightsData, this.highlightsData);
          } else {
            this.highlightsData.length = 0;
          }

          //解决方案
          var soluData;
          if (this.baseData.pContent.technologySolution !== null) {
            soluData = this.baseData.pContent.technologySolution.split(/↵|\n/);
            this.forData(soluData, this.solutionData);
          } else {
            this.solutionData.length = 0;
          }
          //课程大纲
          var courseOutlineTitle = [
            this.baseData.pContent.courseOutlineTitle1,
            this.baseData.pContent.courseOutlineTitle2,
            this.baseData.pContent.courseOutlineTitle3,
            this.baseData.pContent.courseOutlineTitle4,
            this.baseData.pContent.courseOutlineTitle5,
            this.baseData.pContent.courseOutlineTitle6,
            this.baseData.pContent.courseOutlineTitle7,
            this.baseData.pContent.courseOutlineTitle8,
            this.baseData.pContent.courseOutlineTitle9,
            this.baseData.pContent.courseOutlineTitle10,
            this.baseData.pContent.courseOutlineTitle11,
            this.baseData.pContent.courseOutlineTitle12,
            this.baseData.pContent.courseOutlineTitle13,
            this.baseData.pContent.courseOutlineTitle14,
            this.baseData.pContent.courseOutlineTitle15,
            this.baseData.pContent.courseOutlineTitle16,
            this.baseData.pContent.courseOutlineTitle17,
            this.baseData.pContent.courseOutlineTitle18,
            this.baseData.pContent.courseOutlineTitle19,
            this.baseData.pContent.courseOutlineTitle20,
          ];
          var courseOutlineDesc = [
            this.baseData.pContent.courseOutlineDesc1,
            this.baseData.pContent.courseOutlineDesc2,
            this.baseData.pContent.courseOutlineDesc3,
            this.baseData.pContent.courseOutlineDesc4,
            this.baseData.pContent.courseOutlineDesc5,
            this.baseData.pContent.courseOutlineDesc6,
            this.baseData.pContent.courseOutlineDesc7,
            this.baseData.pContent.courseOutlineDesc8,
            this.baseData.pContent.courseOutlineDesc9,
            this.baseData.pContent.courseOutlineDesc10,
            this.baseData.pContent.courseOutlineDesc11,
            this.baseData.pContent.courseOutlineDesc12,
            this.baseData.pContent.courseOutlineDesc13,
            this.baseData.pContent.courseOutlineDesc14,
            this.baseData.pContent.courseOutlineDesc15,
            this.baseData.pContent.courseOutlineDesc16,
            this.baseData.pContent.courseOutlineDesc17,
            this.baseData.pContent.courseOutlineDesc18,
            this.baseData.pContent.courseOutlineDesc19,
            this.baseData.pContent.courseOutlineDesc20,
          ];
          this.infoData(
            courseOutlineTitle,
            courseOutlineDesc,
            this.courseOutData,
            "out"
          );

          var couseOutBase = {};
          var courseOutData = [];
          // 后端数据处理
          this.courseOutData.forEach(function(item) {
            if (item.desc !== null && item.desc !== "") {
              var items = item.desc.split(/;|；/);
              var descData = items.map((val) => {
                var arr = val.split("：");
                return { title: arr[0], conten: arr[1] };
              });
              couseOutBase = {
                titles: item.title
                  .replace(/\[.*?\]/g, "")
                  .replace(/\(.*?\)/g, ""),
                desc: descData,
                video: item.video,
              };
              courseOutData.push(couseOutBase);
            }
          });
          this.courseOutData = courseOutData;
          if (this.demoLink.length === 0) {
            this.$refs.div1.style.display = "none";
          }
          if (this.baseInfo.length === 0) {
            this.$refs.div2.style.display = "none";
          }
          if (this.highlightsData.length === 0) {
            this.$refs.div3.style.display = "none";
          }

          if (this.testImage == null) {
            this.$refs.div4.style.display = "none";
          }

          if (this.solutionData.length === 0) {
            this.$refs.div5.style.display = "none";
          }

          if (this.functionaUrl == null) {
            this.$refs.div6.style.display = "none";
          }
          if (this.technicalUrl == null) {
            this.$refs.div7.style.display = "none";
          }
          if (this.productArchitectureUrl == null) {
            this.$refs.div8.style.display = "none";
          }

          if (this.productStructureUrl == null) {
            this.$refs.div9.style.display = "none";
          }
          if (this.courseOutData.length === 0) {
            this.$refs.div10.style.display = "none";
          }
          if (this.projectSummaryUrl == null) {
            this.$refs.div0.style.display = "none";
          }

          if (this.videoLogoImageUrl == null) {
            this.$refs.div02.style.display = "none";
          }
          if (this.projectToolsl.length === 0) {
            this.$refs.div01.style.display = "none";
          }
        })
        .catch((err) => {
          console.log(999, err);
        });
    },
    getCaption(obj) {
      if (obj.lastIndexOf("[") > 0) {
        obj = obj.substring(obj.indexOf("[") + 1, obj.indexOf("]"));
        return obj;
      }
    },
    infoData(title, desc, items, name) {
      var obj = {};
      for (var f = 0; f < title.length; f++) {
        for (var d = 0; d < desc.length; d++) {
          if (f === d) {
            if (title[f] !== null && title[f] !== "") {
              if (name === "base") {
                var baseInfo = desc[d];
                if (desc[d] !== null && desc[d] !== "") {
                  baseInfo = desc[d].split("\n");
                } else {
                  baseInfo = desc[d];
                }
                obj = {
                  title: title[f],
                  desc: baseInfo,
                };
              } else {
                var videoName = title[f].lastIndexOf("[");
                var videoUrl = title[f].lastIndexOf("(");

                var names = "";
                var urls = "";
                if (videoName > 0) {
                  names = title[f].substring(
                    title[f].indexOf("[") + 1,
                    title[f].indexOf("]")
                  );
                }
                if (videoUrl > 0) {
                  urls = title[f].substring(
                    title[f].indexOf("(") + 1,
                    title[f].indexOf(")")
                  );
                }
                var videoObj = {};

                videoObj = {
                  name: names,
                  url: urls,
                };
                obj = {
                  title: title[f],
                  desc: desc[d],
                  video: videoObj,
                };
              }
              items.push(obj);
            }
          }
        }
      }
    },
    forData(data, items) {
      for (var i = 0; i < data.length; i++) {
        if (data[i] !== "") {
          items.push(data[i]);
        }
      }
    },
    selectMenu(index, event) {
      console.log(event);
      /*if(event._constructed){
        return
      }*/

      this.distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      let jump = this.$refs.rightContent.getElementsByClassName(
        "food-list-hook"
      );
      let total = jump[index].offsetTop; // 获取需要滚动的距离
      this.total = total + 100;
      // Chrome
      document.body.scrollTop = this.total;
      // Firefox
      document.documentElement.scrollTop = this.total;
      // Safari
      window.pageYOffset = this.total;
      this.currentIndex = index;
      this.step = this.total / 50;
      if (this.total > this.distance) {
        this.smoothDown();
      } else {
        let newTotal = this.distance - this.total;
        this.step = newTotal / 50;
        this.smoothUp();
      }
    },
    scrool(pos) {
      console.log(pos);
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      for (var i = 0; i < this.listHeight.length; i++) {
        if (
          this.listHeight[i] < scrolled + 180 &&
          scrolled + 180 < this.listHeight[i + 1]
        ) {
          this.currentIndex = i;
          return false;
        }
      }
    },
    smoothDown() {
      if (this.distance < this.total) {
        this.distance += this.step;
        document.documentElement.scrollTop = this.distance;
        setTimeout(this.smoothDown, 10);
      } else {
        document.body.scrollTop = this.total - 80;
        document.documentElement.scrollTop = this.total - 80;
      }
    },
    smoothUp() {
      if (this.distance > this.total) {
        this.distance -= this.step;
        document.documentElement.scrollTop = this.distance;
        setTimeout(this.smoothUp, 10);
      } else {
        document.body.scrollTop = this.total - 80;
        document.documentElement.scrollTop = this.total - 80;
      }
    },
    _calculateHeight() {
      if (this.$refs.rightContent !== undefined) {
        let foodList = this.$refs.rightContent.getElementsByClassName(
          "food-list-hook"
        );
        let height = 0;
        this.listHeight.push(height);
        for (let i = 0; i < foodList.length; i++) {
          let item = foodList[i];
          height += item.clientHeight;
          this.listHeight.push(height);
        }
      }
    },
    enter(index) {
      this.seen = true;
      this.current = index;
    },
    leave() {
      this.seen = false;
      this.current = null;
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    setIndex(index) {
      if (this.activeIndex === index) {
        this.currents = -1;
        this.activeIndex = -1; //在这里就将它赋值为-1  由于：-1 !=  index 所以其他内容隐藏 ，被点击的则打开
      } else {
        this.activeIndex = index; //这里是把index赋值给isShow，isShow=index则显示
        this.currents = index;
      }
    },

    handleLink(link, e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      window.open(link.video.url, "_self");
    },
    // goTop() {
    //   document.body.scrollTop = document.documentElement.scrollTop = 0;
    // },
  },
  //mounted() {
  //    var self = this;
  //    var liIds = [];
  //    var lis =this.menuData;
  //    for (var i = 0; i < lis.length; i++) {
  //      liIds.push('navon'+i);
  //    }
  //    var $scrollBox = document.querySelector('.container');

  //    var scrollCallback = self.debounce(function () {
  //      var top = $scrollBox.scrollTop; //设置变量top,表示当前滚动条到顶部的值
  //      var tt = $scrollBox.clientHeight; //设置变量tt,表示当前滚动窗口高度的值
  //      var num = 0;
  //      for (var n = 0; n < 7; n++) {
  ////在此处通过判断滚动条到顶部的值和当前窗口高度的关系
  ////（当前窗口的n倍 <= top <= 当前窗口的n+1倍）来取得和导航索引值的对应关系
  //        if (top >= n * tt && top <= (n + 1) * tt) {
  //          num = n;
  //        }
  //        self.isSelected = liIds[num] + '-selected';
  //      }

  //    }, 100)
  //    $scrollBox.addEventListener('scroll', scrollCallback)

  //  }
};
</script>

<style lang="scss">
.app-wrapper {
  .main-container {
    .container {
      .food-list-hook {
        .swiper-button-prev {
          left: -15px !important;
        }
        .swiper-button-next {
          right: 5px !important;
        }
      }
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.bottom {
  p {
    text-align: center;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
.activeClass {
  transform: rotate(90deg);
}
.swiper-slide {
  width: 300px;
  height: 185px;
}
.swiper-slide-invisible-blank {
  display: none;
}
.seeLink {
  // display: inline-block;
  // width:114px;
  // height:34px;
  // text-align: center;
  color: #fff;
  // font-size: 14px;
  padding: 0 35px 0 20px;
  line-height: 34px;
  font-size: 12px;

  background: url(../../../assets/icon_btn.png) no-repeat 75px 50% #1fd29c;
  background-size: 14px 14px;
  border-radius: 4px;
  &:hover {
    background: url(../../../assets/icon_btn.png) no-repeat 75px 50%
      rgba(76, 229, 183, 1);
    background-size: 14px 14px;
    // background:rgba(76,229,183,1);
  }
  &:active {
    background: url(../../../assets/icon_btn.png) no-repeat 75px 50%
      rgba(25, 182, 135, 1);
    background-size: 14px 14px;
    // background:rgba(25,182,135,1);
  }
}
// .seePre{
//   background: url(../../../assets/icon_btn.png) no-repeat 85px 50%;
//   background-size:14px 14px;
//   display: inline-block;
//   width: 94px;
//   height: 25px;
//   padding: 9px 0 0;
//   font-size: 14px;
//   padding-right: 20px;
// }

// .titInfo .goback{
//   background: url(../assets/goback.png) no-repeat 8px 50%;
//   background-size:13px 13px;
//   padding: 0 8px 0 24px;
//   line-height: 24px;
//   border-radius: 12px;
//   color: #495aec;
//   font-size: 12px;
//   &:hover{
//     background: url(../assets/gobackon.png) no-repeat 8px 5px #495aec;
//     background-size:13px 13px;
//     color: #fff;
//   }
// }
</style>
